<template>
  <div class="" v-if="item">
    <div class="w-56 overflow-hidden mb-4">
      <a
        href="mailto:info@agrogo.com.co"
        target="_newtab"
        class="btn-primary-yellow w-full h-11 lg:text-base flex items-center justify-center"
      >
        <span class="icon-mail text-xl mr-4 md:mr-2"></span>
        <p class="break-all" v-html="item.content"></p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      email: null,
    };
  },
};
</script>
